var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_4920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8962 8.9375C48.2947 8.9375 56.3492 12.2738 62.2879 18.2125C68.2265 24.1511 71.5628 32.2056 71.5628 40.6042C71.5628 49.0027 68.2265 57.0572 62.2879 62.9959C56.3492 68.9345 48.2947 72.2708 39.8962 72.2708C31.4976 72.2708 23.4431 68.9345 17.5044 62.9959C11.5658 57.0572 8.22949 49.0027 8.22949 40.6042C8.22949 32.2056 11.5658 24.1511 17.5044 18.2125C23.4431 12.2738 31.4976 8.9375 39.8962 8.9375Z",
    fill: "url(#paint0_radial_178_4920)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8956 10.5374C31.9214 10.5374 24.2738 13.7051 18.6352 19.3437C12.9966 24.9823 9.82891 32.6299 9.82891 40.6041C9.82891 48.5782 12.9966 56.2258 18.6352 61.8644C24.2738 67.503 31.9214 70.6707 39.8956 70.6707C47.8697 70.6707 55.5173 67.503 61.1559 61.8644C66.7945 56.2258 69.9622 48.5782 69.9622 40.6041C69.9622 32.6299 66.7945 24.9823 61.1559 19.3437C55.5173 13.7051 47.8697 10.5374 39.8956 10.5374ZM16.3725 17.081C22.6112 10.8423 31.0727 7.3374 39.8956 7.3374C48.7184 7.3374 57.1799 10.8423 63.4187 17.081C69.6574 23.3197 73.1622 31.7812 73.1622 40.6041C73.1622 49.4269 69.6574 57.8884 63.4187 64.1272C57.1799 70.3659 48.7184 73.8707 39.8956 73.8707C31.0727 73.8707 22.6112 70.3659 16.3725 64.1272C10.1338 57.8884 6.62891 49.4269 6.62891 40.6041C6.62891 31.7812 10.1338 23.3197 16.3725 17.081Z",
    fill: "url(#paint1_radial_178_4920)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1318 27.3685C53.7566 27.9934 53.7566 29.0064 53.1318 29.6313L29.1318 53.6313C28.5069 54.2561 27.4939 54.2561 26.869 53.6313C26.2442 53.0064 26.2442 51.9934 26.869 51.3685L50.869 27.3685C51.4939 26.7437 52.5069 26.7437 53.1318 27.3685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.869 27.3685C27.4939 26.7437 28.5069 26.7437 29.1318 27.3685L53.1318 51.3685C53.7566 51.9934 53.7566 53.0064 53.1318 53.6313C52.5069 54.2561 51.4939 54.2561 50.869 53.6313L26.869 29.6313C26.2442 29.0064 26.2442 27.9934 26.869 27.3685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_178_4920",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.4595 88.8642) rotate(-134.873) scale(131.193 446.292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_178_4920",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.8621 91.3025) rotate(-134.873) scale(137.822 468.842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_4920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorClose);
export default __webpack_public_path__ + "static/media/color_close.fec8d6719ba24a23175e17e8dd144539.svg";
export { ForwardRef as ReactComponent };